import React from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export const HEAD = "font-['Outfit'] tracking-tight";
export const mask = (id, hide) => (hide ? "•".repeat((id || "").length || 10) : id);
export const shortId = (id) => (id && id.length > 8 ? `${id.slice(0, 4)}…${id.slice(-4)}` : id || "");
export const copyText = (text, label) =>
  navigator.clipboard.writeText(text).then(() => toast.success(`Copied ${label}`)).catch(() => toast.error("Copy failed"));
export const cdFilename = (res, fallback) =>
  /filename="?([^";]+)"?/.exec(res.headers?.["content-disposition"] || "")?.[1] || fallback;
export const fmtIst = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true }) : "";

export function Pill({ on, onClick, children, testid, tone = "green" }) {
  const onCls = tone === "brown" ? "bg-[#8A6046] text-white border-[#8A6046] shadow-sm" : "bg-[#385C4B] text-white border-[#385C4B] shadow-sm";
  return (
    <button onClick={onClick} data-testid={testid}
      className={`h-8 px-3.5 text-xs font-semibold rounded-full border whitespace-nowrap transition-[background-color,color,transform] active:scale-95 ${on ? onCls : "bg-white text-[#3A3A35] border-[#E0DFD6] hover:bg-[#EFEEE6]"}`}>
      {children}
    </button>
  );
}

export function PdLoading() {
  return (
    <div className="py-12 text-center text-sm text-[#6B6B61]" data-testid="pd-loading">
      <Loader2 className="w-5 h-5 animate-spin inline mr-2" />Loading…
    </div>
  );
}
